module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_Vitra02.0094.png.aa6d0123.jpg";